import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers';

const billingInfo = Loadable(() => isFuncComp() ? import('../../FuncContainers/billingInfo') : import('../../containers/web/billingInfo'));
export default MapTo('vcg/components/soe-home/react/billingInfo')(billingInfo);
